import React, {useCallback, useEffect, useMemo, useState} from "react";
import axios from "../../../../util/axios";
import {getType} from "../../../../util/component/Utils/util";


const DocList = (props, _ref) => {
    const {equisData,setEquisDetailData,equisSearch,SearchString} = props


    const [product,setProduct] = useState([]);


    const docListClick = (data) =>{
        setEquisDetailData(data);
    }
    useEffect(  () => {
        getEquisProduct()

    }, [])

    const getEquisProduct = async () => {
        const uri = '/veeva/retrieveEquisPicklistByQuery';
        const ProcessResponse = await axios.post(process.env.REACT_APP_API + uri, {value: "product__v"});
        setProduct(ProcessResponse.data.data.result ? ProcessResponse.data.data.result : []);
    }

    const renderDocList = useMemo(() => {

        const search =(rowData)=>{
            const type = getType(rowData[equisSearch.value]);
            if(type === "String"){
                return SearchString && rowData[equisSearch.value].toLowerCase().includes(SearchString.toLowerCase())
            }else if(type === "Array" && equisSearch.value !== "product__v"){
                return SearchString && (rowData[equisSearch.value].filter(data => data.toLowerCase().includes(SearchString.toLowerCase())).length > 0)
            }else if(equisSearch.value === "product__v"){
                return SearchString && (rowData[equisSearch.value].filter(
                    data => product.filter(d => d.label.toLowerCase().includes(SearchString.toLowerCase())).filter(d2 => d2.value === data).length >0
                ).length > 0)
            }
        }

        return equisData.map((rowData, index) => {
            if(search(rowData)){
                return (
                    <tr key={"equisList" + index}>
                        <td onClick={() =>docListClick(rowData)}>{rowData.name__v}( {rowData.major_version_number__v}.{rowData.minor_version_number__v} )</td>
                    </tr>
                );
            }else if( !SearchString){
                return (
                    <tr key={"equisList" + index}>
                        <td onClick={() =>docListClick(rowData)}>{rowData.name__v}( {rowData.major_version_number__v}.{rowData.minor_version_number__v} )</td>
                    </tr>
                );
            }

        });
    }, [equisData,equisSearch,SearchString]);
    return (
        <div className={"equis-div"}>
            <table className={"bpl-table-default docTable"}>
                <tbody>
                {renderDocList}
                </tbody>
            </table>
        </div>
    )
}

export default React.memo(DocList);